import React from 'react';
import { Link } from 'react-router-dom';
import pluralize from 'pluralize';

// material ui
import Button from '@material-ui/core/Button';

import InfoIcon from '@material-ui/icons/InfoOutlined';

import AppActions from '../../actions/app-actions';
import AppStore from '../../stores/app-store';
import { preformatWithRequestID, getUserRoleFromJWT } from '../../helpers';
import Loader from '../common/loader';
import { DevicePendingTip } from '../helptips/onboardingtips';
import DeviceList from './devicelist';
import { getOnboardingComponentFor, advanceOnboarding } from '../../utils/onboardingmanager';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ConfigProvision from '../configurations/config-provision'

export default class Pending extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      count: 0,
      devices: [],
      pageNo: 1,
      pageLength: 20,
      selectedRows: [],
      showHelptips: AppStore.showHelptips(),
      refreshDeviceLength: 10000,
      authLoading: 'all',
      pageLoading: true,
      chooseConfig: false,
      currentUserRole: getUserRoleFromJWT(),
    };

    /** Bind methods to avoid method re-creation */
    this._triggerRefreshTimerBind = this._triggerRefreshTimer.bind(this);
    this._getDevicesBind = this._getDevices.bind(this);
    this._onRowSelectionBind = this._onRowSelection.bind(this);
    this._handlePageChangeBind = this._handlePageChange.bind(this);

    /** local property */
    this._unmountError = 'Component unmounted';
  }

  componentDidMount() {
    this._isMounted = true;
    this._getDevices();
  }
  componentWillUnmount() {
    this._triggerRefreshTimer(false);
    this._isMounted = false;
  }

  _triggerRefreshTimer(trigger) {
    if (trigger && !this.timerId && this._isMounted) {
      this.timerId = setTimeout(this._getDevicesBind, this.state.refreshDeviceLength);
    } else if(!trigger && this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;      
    }
  }

  /*
   * Devices to show
   */
  _getDevices() {
    this._triggerRefreshTimer(false);
    Promise.all([
      AppActions.getDeviceCount('pending'),
      AppActions.getDevicesByStatus('pending', this.state.pageNo, this.state.pageLength)])
      .then((results) => {
        if (!this._isMounted) {
          throw new Error(this._unmountError);
        }
        return results;
      })
      .then((results) => {
        let count = results[0];
        let devices = results[1];
        //if devices empty but count not, make both be empty
        if (!(count && devices.length)) {
          count = 0;
          devices = [];
        }
        this.setState({count, devices, pageLoading: false, authLoading: null}, () => {
          this._triggerRefreshTimer(true);
        });
      })
      .catch((error) => {
        if (error.message !== this._unmountError) {
          const errorMsg = (error && error.error && error.error.message) || 'Please check your connection.';
          this.setState({count: 0, devices: [], pageLoading: false, pageNo: 1, authLoading: null}, () => {
            this._triggerRefreshTimer(true);
            AppActions.setSnackbar(errorMsg, 5000, '');
          });
        }
      });
  }

  _handlePageChange(pageNo) {
    this.setState({pageLoading: true, selectedRows: [], pageNo}, () => {
      this._getDevices();
    });
  }

  _getDevicesFromSelectedRows() {
    // use selected rows to get device from corresponding position in devices array
    const self = this;
    const devices = self.state.selectedRows.map(row => self.state.devices[row]);
    return devices;
  }

  _getSnackbarMessage(skipped, done) {
    pluralize.addIrregularRule('its', 'their');
    var skipText = skipped
      ? `${skipped} ${pluralize('devices', skipped)} ${pluralize('have', skipped)} more than one unauthorized authset. Expand ${pluralize(
        'this',
        skipped
      )} ${pluralize('device', skipped)} to individually adjust ${pluralize('their', skipped)} authorization status. `
      : '';
    var doneText = done ? `${done} ${pluralize('device', done)} ${pluralize('was', done)} updated successfully. ` : '';
    AppActions.setSnackbar(doneText + skipText);
  }

  _authorizeDevices(type, flavor_name, config_name, label) {
    var self = this;
    var devices = this._getDevicesFromSelectedRows();
    self.setState({ authLoading: true });
    var skipped = 0;
    var count = 0;

    // for each device, get id and id of authset & make api call to accept
    // if >1 authset, skip instead
    const deviceAuthUpdates = devices.map(device => {
      if (device.auth_sets.length !== 1) {
        skipped++;
        return Promise.resolve();
      }
      // api call device.id and device.authsets[0].id
      return AppActions.updateDeviceAuth(device.id, device.auth_sets[0].id, 'accepted', type, flavor_name, config_name, label)
        .then(() => count++)
        .catch(err => {
          var errMsg = err.res.error.message || '';
          console.log(errMsg);
          // break if an error occurs, display status up til this point before error message
          self._getSnackbarMessage(skipped, count);
          setTimeout(() => {
            AppActions.setSnackbar(
              preformatWithRequestID(err.res, `The action was stopped as there was a problem updating a device authorization status: ${errMsg}`),
              null,
              'Copy to clipboard'
            );
            self.setState({ selectedRows: [] });
            //self.props.restart();
          }, 4000);
          self.break;
        });
    });
    return Promise.all(deviceAuthUpdates).then(() => {
      self._getSnackbarMessage(skipped, count);
      // refresh devices by calling function in parent
      //self.props.restart();
      self.setState({ selectedRows: [] });
    });
  }

  _onRowSelection(selection) {
    if (!AppStore.getOnboardingComplete()) {
      advanceOnboarding('devices-pending-accepting-onboarding');
    }
    this.setState({ selectedRows: selection });
  }
  
  toggleChooseConfig(chooseConfig = !this.state.chooseConfig) {
    this.setState({ chooseConfig });
  }

  updateConfig = (type, flavor_name, config_name, label) => {
    this._authorizeDevices(type, flavor_name, config_name, label);
    this.toggleChooseConfig(false);
  }

  render() {
    const self = this;
    const deviceLimit = AppStore.getDeviceLimit();
    const highlightHelp = !AppStore.getTotalAcceptedDevices();
    var limitMaxed = deviceLimit ? deviceLimit <= this.props.acceptedDevices : false;
    var limitNear = deviceLimit ? deviceLimit < this.props.acceptedDevices + this.state.devices.length : false;
    var selectedOverLimit = deviceLimit ? deviceLimit < this.props.acceptedDevices + this.state.selectedRows.length : false;
    const deviceConnectingProgressed = AppStore.getDeviceConnectionProgressed();

    const chooseConfigTitle = 'Authorize Selected Devices';
    var deviceLimitWarning =
      limitMaxed || limitNear ? (
        <p className="warning">
          <InfoIcon style={{ marginRight: '2px', height: '16px', verticalAlign: 'bottom' }} />
          {limitMaxed ? <span>You have reached</span> : null}
          {limitNear && !limitMaxed ? <span>You are nearing</span> : null} your limit of authorized devices: {this.props.acceptedDevices} of{' '}
          {deviceLimit}
        </p>
      ) : null;

    let onboardingComponent = null;
    if (this.deviceListRef || this.authorizeRef) {
      const element = this.deviceListRef ? this.deviceListRef.getElementsByClassName('body')[0] : null;
      onboardingComponent = getOnboardingComponentFor('devices-pending-onboarding', {
        anchor: { left: 200, top: element ? element.offsetTop + element.offsetHeight : 170 }
      });
      if (this.state.selectedRows && this.authorizeRef) {
        const anchor = {
          left: this.authorizeRef.offsetLeft - this.authorizeRef.offsetWidth / 2,
          top: this.authorizeRef.offsetParent.offsetTop - this.authorizeRef.offsetParent.offsetHeight - this.authorizeRef.offsetHeight / 2
        };
        onboardingComponent = getOnboardingComponentFor('devices-pending-accepting-onboarding', { place: 'left', anchor });
      }
    }

    return (
      <div className="tab-container">
        <Loader show={this.state.authLoading} />

        {this.state.devices.length && (!this.state.pageLoading || this.state.authLoading !== 'all') ? (
          <div className="padding-bottom" ref={ref => (this.deviceListRef = ref)}>
            <h3 className="align-center">
              {this.state.count} {pluralize('devices', this.state.count)} Unauthorized authorization
            </h3>
            {deviceLimitWarning}
            <DeviceList
              {...self.props}
              {...self.state}
              className="pending"
              limitMaxed={limitMaxed}
              onSelect={self._onRowSelectionBind}
              onPageChange={self._handlePageChangeBind}
              pageTotal={self.state.count}
              refreshDevices={self._getDevicesBind}
              type="pending"
              highlightHelp={highlightHelp}
              updateRefreshTimer={this._triggerRefreshTimerBind}
            />
          </div>
        ) : (
          <div>
            {self.state.showHelptips && deviceConnectingProgressed ? (
              <DevicePendingTip />
            ) : (
              <div className={this.state.authLoading ? 'hidden' : 'dashboard-placeholder'}>
                <p>There are no devices unauthorized authorization</p>
                {highlightHelp ? (
                  <p>
                    Visit the <Link to="/help/getting-started">Help section</Link> to learn how to connect devices to the Mender server.
                  </p>
                ) : null}
              </div>
            )}
          </div>
        )}

        {this.state.selectedRows.length ? (
          <div className="fixedButtons">
            <div className="float-right">
              {this.state.authLoading ? <Loader style={{ width: '100px', top: '7px', position: 'relative' }} table={true} waiting={true} show={true} /> : null}

              <span className="margin-right">
                {this.state.selectedRows.length} {pluralize('devices', this.state.selectedRows.length)} selected
              </span>
              <Button
                variant="contained"
                disabled={this.props.disabled || limitMaxed || selectedOverLimit || (this.state.currentUserRole !== 'admin')}
                onClick={() => this.toggleChooseConfig(true)}
                color="primary"
              >
                {`Authorize ${this.state.selectedRows.length} ${pluralize('devices', this.state.selectedRows.length)}`}
              </Button>
              {deviceLimitWarning}
            </div>
          </div>
        ) : null}
        {onboardingComponent ? onboardingComponent : null}

        <Dialog
          open={self.state.chooseConfig}
          maxWidth="lg"
          style={{
            paddingTop: '0',
            fontSize: '13px',
            overflow: 'hidden'
          }}
        >
          <DialogTitle>{chooseConfigTitle}</DialogTitle>
          <DialogContent>
            <ConfigProvision
              dialogToggle={() => this.toggleChooseConfig(false)}
              confirmAll={this.updateConfig}
              provision={true}
            />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
